$shm_projects_digest_day $mol_view
	sub /
		<= Head $mol_view
			sub /
				<= Title $mol_text text \**Итоги дня**
				<= Refresh $mol_button_minor
					title \Обновить
					click? <=> refresh? null
		<= Text $mol_text
			text <= text \
